import React, { useState } from 'react'
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from '@material-ui/core/Typography';
import { makeStyles } from "@material-ui/core/styles";
import { Link, useLocation  } from 'react-router-dom';

//Imagenes
import logo from "assets/img/dox-wp-logo.png";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1
  },
  title: {
    flexGrow: 1,
  },
}));

// import Header from "components/Header/Header.js"
// import HeaderLinks from "components/Header/HeaderLinks.js";

export default function Cabecera(props) {

  const [isHovered1, setIsHovered1] = useState(false);
  const [isHovered2, setIsHovered2] = useState(false);

  const classes = useStyles();

  const linkStyle1 = {
    backgroundColor: isHovered1 ? "#16162E" : "#8FC600",
    paddingLeft: "1.5rem",
    paddingRight: "1.5rem",
    paddingTop: "0.5rem",
    paddingBottom: "0.5rem",
    borderRadius: "30px",
    textDecoration: "none",
    color: "#ffffff",
    transition: "background-color 0.15s ease-in-out", // Transición suave
  };

  const location = useLocation();

  const handleMouseEnter1 = () => {
    setIsHovered1(true);
  };

  const handleMouseLeave1 = () => {
    setIsHovered1(false);
  };

  const handleMouseEnter2 = () => {
    setIsHovered2(true);
  };

  const handleMouseLeave2 = () => {
    setIsHovered2(false);
  };

  const isActive = (path) => {
    return location.pathname === path
  };

  function getWPUrl(path) {
    return path ? window.urlWP + path : window.urlWP;
  }

  return (
    <div className={classes.root}>
      {/* <Header
        logo={logo}
        brand="FIRMADOX"
        links={<HeaderLinks dropdownHoverColor="info" />}
        fixed
        color={props.color}
        changeColorOnScroll={{
          height: 200,
          color: "gray"
        }}
      /> */}
      <AppBar position="static" style={{backgroundColor: "white", fontSize: "18px", fontWeight: "400"}}>
        <Toolbar style={{ marginTop: '1.5rem', marginBottom: '1.5rem', marginLeft: '3.2rem', marginRight: '3.2rem' }}>
          <Typography variant="h6" className={classes.title}>
              <img src={logo} alt="Logo" style={{ height: '3.7rem', cursor: "pointer"}} onClick={e => window.open(getWPUrl(), '_self')}/>
          </Typography>
          <Link to="#"
            onClick={e => window.open(getWPUrl(), '_self')}
            style={{ textDecoration: 'none', marginRight: '2.5rem', color: "#8FC600" }}
          >Inicio</Link>
          <Link to="/menu/atencionEnLinea"
            style={{ textDecoration: 'none', marginRight: '2.5rem', color: isHovered2 ? "#8FC600" : isActive('/menu/atencionEnLinea') ? "#8FC600" : "#747474" }}
            onMouseEnter={handleMouseEnter2}
            onMouseLeave={handleMouseLeave2}
          >Atención en línea</Link>
          <Link to="#"
            onClick={e => window.open(getWPUrl("/contacto"), '_self')}
            style={linkStyle1}
            onMouseEnter={handleMouseEnter1}
            onMouseLeave={handleMouseLeave1}
          >Contáctanos</Link>
        </Toolbar>
      </AppBar>
    </div>
  )
}
